<template>
  <form class="p-2" @submit.prevent="handleFlightMode">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <modal-container :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0 text-capitalize">{{ $t("turn_on_flight_mode") }}</h4>
      </template>

      <template slot="body">
        <div style="min-height: 20rem;">
          <div class="align-items-center d-flex col-gap-1 mb-3">
            <div class="form-group w-100">
              <label for="into_flight_date">
                {{ $t("into_flight_date") }}
              </label>
              <input
                type="date"
                v-model="into_flight_date"
                class="form-control text-uppercase"
                required
                id="into_flight_date"
                :min="new Date().toISOString().slice(0, 10)"
              />
            </div>

            <div class="form-group w-100">
              <label for="into_flight_time">
                {{ $t("into_flight_time") }}
              </label>
              <input
                type="time"
                v-model="into_flight_time"
                class="form-control"
                required
                id="into_flight_time"
              />
            </div>
          </div>

          <div class="align-items-center d-flex col-gap-1">
            <div class="form-group w-100">
              <label for="out_flight_date"> {{ $t("out_flight_date") }} </label>
              <input
                type="date"
                v-model="out_flight_date"
                class="form-control text-uppercase"
                required
                id="out_flight_date"
                :min="into_flight_date"
              />
            </div>

            <div class="form-group w-100">
              <label for="out_flight_time">
                {{ $t("out_flight_time") }}
              </label>
              <input
                type="time"
                v-model="out_flight_time"
                class="form-control"
                required
                id="out_flight_time"
              />
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ $t("turn_on") }}
          </button>
        </div>
      </template>
    </modal-container>
  </form>
</template>

<script>
import ModalContainer from "../../components/ModalContainer.vue";
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    ModalContainer,
    Loading,
  },
  props: {
    show: Boolean,
    onCancel: Function,
  },
  name: "FlightModeModal",
  data() {
    return {
      into_flight_date: "",
      into_flight_time: "",
      out_flight_date: "",
      out_flight_time: "",
      isLoading: false,
      fullPage: true,
    };
  },
  methods: {
    ...mapActions(["updateFlightMode"]),

    handleFlightMode() {
      const payload = {
        startDate: new Date(
          `${this.into_flight_date}T${this.into_flight_time}`
        ),
        endDate: new Date(`${this.out_flight_date}T${this.out_flight_time}`),
        enableFlightMode: true,
      };

      this.isLoading = true;
      this.updateFlightMode({
        device_id: this.$route.params.device_id,
        flightMode: payload,
      })
        .then(() => {
          this.isLoading = false;
          this.$emit("flightMode");
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error updating flight mode", error);
        });
    },
  },
};
</script>
